import { useState, useEffect } from 'react'

import CircularProgress from '@mui/material/CircularProgress'
import axios from 'axios'
import Head from 'next/head'
import Link from 'next/link'
import { useRouter } from 'next/router'

import Footer from '../../components/Footer/index'
import Cards from '../../components/mobadra/Cards'
export default function Mobadrat() {
  const { locale } = useRouter()
  const [initiativeTrans, setInitiativeTrans] = useState({})
  const [initiativeContent, setInitiativeContent] = useState([])
  const [loading, setLoading] = useState(false)

  const fetchInitiativeTrans = async () => {
    setLoading(true)
    const response = await axios({
      method: 'GET',
      url: `/local_industry/translation`,
    })
    setInitiativeTrans(response?.data)
    setLoading(false)
  }

  const fetechInitiativeContent = async () => {
    const response = await axios({
      method: 'GET',
      url: `/local_industry`,
    })
    setInitiativeContent(response?.data)
  }

  useEffect(() => {
    fetchInitiativeTrans()
    fetechInitiativeContent()
  }, [locale])

  const schema = initiativeContent?.rows?.map((item) => {
    return {
      '@context': 'https://schema.org',
      '@type': 'NewsArticle',
      headline: item?.title,
      image: Object.keys(item.field_icons.split(', ')).map((index) => item?.field_icons),
      author: {
        '@type': 'Person',
        name: item?.title.substring(0, 100) + '...',
        url: `${process.env.NEXT_PUBLIC_BASE_URL}/issi/${item?.nid}`,
      },
    }
  })

  return (
    <>
      <Head>
        <title>
          {locale === 'en'
            ? `Ministry of Industry and Mineral Resources - ${initiativeTrans?.page_title}`
            : `وزارة الصناعة والثروة المعدنية - ${initiativeTrans?.page_title}`}
        </title>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
          key="news-jsonld"
        />
      </Head>
      <section className="bg-cover ltr:-scale-x-100 min-h-[200px] md:h-[297px] flex items-center relative py-4 bg-[#262626] bg-[url('/images/newimg/iii.png')] before:absolute before:bg-[url('/images/banner-overly.png')] before:bg-no-repeat before:bg-cover before:left-0 before:top-0 before:h-full before:w-full before:mix-blend-multiply">
        <div className="container px-4 mx-auto relative ltr:-scale-x-100">
          <h1 className=" text-white lyon leading-normal">{initiativeTrans?.page_title}</h1>
          <h5 className="text-white lyon mt-4">{initiativeTrans?.page_title}</h5>
          <nav aria-label="Breadcrumb">
            <ol className="inline-flex flex-wrap items-center text-light-gray mt-4 text-body-md font-lyon-semibold">
              {initiativeTrans?.breadcrumb?.length > 0 &&
                initiativeTrans?.breadcrumb?.map((item, ind) => (
                  <li className={`${ind > 0 ? "before:content-['/'] before:mx-2" : null}`} key={ind}>
                    {initiativeTrans?.breadcrumb?.length === ind + 1 ? (
                      <span className="text-light-gray capitalize">{item?.label}</span>
                    ) : (
                      <Link href={item?.url}>
                        <a className="text-light-gray hover:text-greenscale-500 capitalize" aria-label={item?.title}>
                          {item?.label}
                        </a>
                      </Link>
                    )}
                  </li>
                ))}
            </ol>
          </nav>
        </div>
      </section>
      {loading ? (
        <div className="flex justify-center items-center loader-items py-10 min-h-[300px]">
          <CircularProgress style={{ color: '#1AD9C7' }} />
        </div>
      ) : (
        <section id="initMenu" className="bg-[#f9f9fb] w-full sticky top-0 left-0 z-[8] py-[48px]">
          <div className="container px-4 mx-auto flex flex-wrap">
            {initiativeContent?.rows?.length > 0 &&
              initiativeContent?.rows?.map((item) => (
                <Cards initiativeTrans={initiativeTrans} item={item} key={item.nid} />
              ))}
          </div>
        </section>
      )}
    </>
  )
}
